import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  InputGroupAddon,
  DropdownItem,
  DropdownMenu,
  ButtonDropdown,
  Card,
  CardBody,
  InputGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { localeOptions } from '../../../../../../constants/defaultValues';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import CodeSnippet from './CodeSinppet';
import Select from 'react-select';
import { post_API_Send_Email_Instructions } from '../../../../../../constants/APIs';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Addons({
  saveIntegration,
  channelDetails,
  propertyId,
  integrationId,
  serviceProvider,
  allProperties,
}) {
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [emailInput, setEmailInput] = useState({
    email: "",
    placeHolder: ""
  });
  const [showEmailBox, setShowEmailBox] = useState(false);
  const [propertyEmails, setPropertyEmails] = useState([]);
  useEffect(() => {
    if (
      channelDetails?.addOn?.emails &&
      channelDetails?.addOn?.emails.length > 0
    ) {
      let lst = [];
      channelDetails.addOn.emails.map((m) => {
        let propList = [];
        if (m?.properties) {
          propList = m?.properties.map((p) => {
            if (allProperties.filter((f) => f.id === p).length > 0) {
              let obj = allProperties.filter((f) => f.id === p)[0];
              return { key: obj.id, value: obj.id, label: obj.name };
            }
          });
        }
        console.log(propList, 'propList');
        lst.push({ email: m.email, properties: propList, language: m.language });
      });

      setPropertyEmails(lst);
    }
  }, [propertyId]);
  const SendEmail = () => {

    let data = {
      groupId: getGroupID(),
      intregationId: integrationId,
      propertyId: propertyId === "-1" ? null : propertyId,
      type: "Outlook",
      ...emailInput
    };
    AxiosAPI({
      method: 'post',
      url: `${post_API_Send_Email_Instructions}`,
      data,
    })
  };
  const handleSave = (e) => {
    var details = { ...channelDetails };
    let lst = [...propertyEmails];
    lst.filter(f => f.properties !== undefined).map(m => m.properties = m.properties.map(p => p.value));
    details.addOn.emails = lst;
    saveIntegration({ channelDetails: details });
  };

  const handleAddEmails = () => {

    let propEmails = [...propertyEmails];
    propEmails.push({ email: '', language: 'en', properties: [] });
    setPropertyEmails(propEmails);
  };

  const handlRemove = (e) =>
    setPropertyEmails(propertyEmails.filter((f, index) => index !== e));

  const handleChange = (e, index, name) => {
    let lst = [...propertyEmails];
    lst[index][name] = e.target.value;
    setPropertyEmails(lst);
  };

  const handleSelectChange = (val, index) => {
    console.log(val, index);
    let lst = [...propertyEmails];
    lst[index].properties = val;
    setPropertyEmails(lst);
  };
  console.log(propertyEmails, 99);
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Microsoft Outlook Add-on</h6>
            <span>Generate AI reply to emails without leaving outlook</span>
          </div>
          <Separator className="mb-3" />
          <Card className="m-4">
            <Colxx xxs="12" className="p-4">
              <div className="text-left">
                <h6>Authorized Email Addresses</h6>
                <p className="my-1">
                  List email addresses that are allowed to connect from Outlook
                </p>
              </div>
              {propertyEmails.map((m, index) => (
                <div className="row mb-2">
                  <div className="col-md-5 pr-2">
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      isMulti={true}
                      classNamePrefix="react-select"
                      name="form-field-name"
                      options={allProperties.map((x, i) => {
                        return {
                          label: x.name,
                          value: x.id,
                          key: i,
                        };
                      })}
                      value={m?.properties ?? []
                      }
                      onChange={(val) => handleSelectChange(val, index)}
                    />
                  </div>
                  <div className="col-md-6 d-flex align-items-center px-0">
                    <InputGroup>
                      <Input
                        value={m?.email}
                        type="text"
                        onChange={(e) => handleChange(e, index, 'email')}
                      ></Input>
                      <InputGroupAddon addonType="append" className="pl-2">
                        <Input
                          type="select"
                          value={m?.language}
                          onChange={(e) => handleChange(e, index, 'language')}
                        >
                          <option value="">Please select</option>
                          {localeOptions.map((elem) => (
                            <option value={elem.id}>{elem.name}</option>
                          ))}
                        </Input>
                      </InputGroupAddon>
                    </InputGroup>
                  </div>
                  <div className="col-md-1 d-flex align-items-center pr-0">
                    <Button
                      color="danger"
                      outline
                      size="xs"
                      onClick={() => handlRemove(index)}
                    >
                      X
                    </Button>
                  </div>
                </div>
              ))}
              <div className="row mt-2 ml-1">
                <div className="d-flex w-100">
                  <Button
                    color="primary"
                    outline
                    size="xs"
                    onClick={handleAddEmails}
                  >
                    + Add Email
                  </Button>
                </div>
              </div>
              <Row>
                <CodeSnippet
                  propertyId={propertyId}
                  allProperties={allProperties}
                  integrationId={integrationId}
                  serviceProvider={serviceProvider}
                ></CodeSnippet>
              </Row>
              <div className="text-center">
                <Button color="primary" className='mr-2' outline size="xs" onClick={() => setShowEmailBox(!showEmailBox)}>
                  Send instructions to Microsoft Admin
                </Button>
              </div>
            </Colxx>
          </Card>
          <Separator className="my-3" />
          <Modal className='intregation-modal-content' style={{ borderRadius: '10px', marginTop: '100px' }} isOpen={showEmailBox} toggle={() => setShowEmailBox(!showEmailBox)}>
            <ModalHeader toggle={() => setShowEmailBox(!showEmailBox)}>
              Send instructions to Microsoft Administrator
            </ModalHeader>
            <ModalBody>
              <Card className="">
                <Colxx xxs="12" className="py-2">
                  <div className="my-2">
                    <p>Email:</p>
                    <p>
                      <Input
                        className='my-2'
                        type="text"
                        name="email"
                        value={emailInput.email}
                        placeholder="E-mail"
                        onChange={(e) => setEmailInput({ ...emailInput, email: e.target.value })}
                      />
                    </p>
                    <p>Message:</p>
                    <p>
                      <Input
                        className='my-2'
                        type="text"
                        name="placeHolder"
                        value={emailInput.placeHolder}
                        placeholder="Message"
                        onChange={(e) => setEmailInput({ ...emailInput, placeHolder: e.target.value })}
                      />
                    </p>
                  </div>
                </Colxx>
              </Card>
            </ModalBody>
            <ModalFooter className='justify-content-center'>
              <Button
                color="success"
                size="xs"
                onClick={() => { SendEmail(); setEmailInput({ email: "", placeHolder: "" }); setShowEmailBox(!showEmailBox); }}
              >
                <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon><span className='ml-2' >Send</span>
              </Button>
            </ModalFooter>
          </Modal>
          <Colxx md="12" className="text-center mb-2">

            <Button onClick={() => handleSave()} color="primary" className='mt-1' size="xs">
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
